import { PdpPhaseDTO, PlanStatusDTO } from '@/types/models'

export function pdpPhasesMap(items: PdpPhaseDTO[]): PdpPhaseDTO[] {
  const currentDate = new Date()
  let inProgressFound = false
  let nextFound = false

  return items
    .sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    )
    .map((item) => {
      const itemDate = new Date(item.startDate)

      if (itemDate < currentDate) {
        return { ...item, status: 'done' }
      } else if (!inProgressFound) {
        inProgressFound = true
        return { ...item, status: 'in_progress' }
      } else if (!nextFound) {
        nextFound = true
        return { ...item, status: 'next' }
      } else {
        return { ...item, status: 'pending' }
      }
    })
}

export const planPhaseMapper: Record<PlanStatusDTO, string> = {
  notStarted: 'به زودی',
  inProgress: 'درحال سرمایه گذاری',
  funded: 'تامین شده',
  pending: 'در حال',
  expired: 'تکمیل شده',
  finish: 'اتمام طرح',
}
